import Category from "@/models/Category";
import Tag from "@/models/Tag";
import Task from "@/models/Task";
import { StorageService } from "./StorageService";

export class LocalStorageService implements StorageService {
  keyPrefix: string;

  constructor(keyPrefix: string) {
    this.keyPrefix = keyPrefix;
  }

  private getKey(name: string): string {
    return `${this.keyPrefix}_${name}`;
  }

  async getTasks(): Promise<Task[]> {
    const data = localStorage.getItem(this.getKey("tasks"));
    const parsed = data ? JSON.parse(data) : [];
    return parsed.map((item: any) => Task.fromJSON(item));
  }

  async getCategories(): Promise<Category[]> {
    const data = localStorage.getItem(this.getKey("categories"));
    const parsed = data ? JSON.parse(data) : [];
    return parsed.map((item: any) => Category.fromJSON(item));
  }

  async getTags(): Promise<Tag[]> {
    const data = localStorage.getItem(this.getKey("tags"));
    const parsed = data ? JSON.parse(data) : [];
    return parsed.map((item: any) => Tag.fromJSON(item));
  }

  async saveTasks(tasks: Task[]): Promise<void> {
    localStorage.setItem(
      this.getKey("tasks"),
      JSON.stringify(tasks.map((task) => task.toJSON())),
    );
  }

  async saveCategories(categories: Category[]): Promise<void> {
    localStorage.setItem(
      this.getKey("categories"),
      JSON.stringify(categories.map((cat) => cat.toJSON())),
    );
  }

  async saveTags(tags: Tag[]): Promise<void> {
    localStorage.setItem(
      this.getKey("tags"),
      JSON.stringify(tags.map((tag) => tag.toJSON())),
    );
  }
}
